export const ROUTES = {
  // Public routes
  HOME: '/',
  PRODUCTS: '/products',
  CARTS: '/carts',
  SHOPPING_LISTS: '/shopping-lists',
  LOGIN: '/login',
  SEARCH: '/search',
  SUPERMARKETS: '/supermarkets',
  SUPERMARKET_PRODUCTS: '/supermarkets/:supermarketId/products',
  PRODUCT_DETAILS: '/supermarkets/:supermarketId/products/:productId',
  CHECKOUT: '/checkout/:supermarketId/:cartInstanceId',
  PAYMENT: '/payment/:transactionId',
  ORDER_STATUS: '/order-status/:transactionId',
  ORDER_HISTORY: '/order-history',
  PAYMENT_RESPONSE: '/payment/response',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
  REFUND_POLICY: '/refund-policy',
  HOW_IT_WORKS: '/how-it-works',
  FAQ: '/faq',

  // Protected routes
  INVENTORY: '/inventory',
  INVENTORY_CREATE: '/inventory/create',
  INVENTORY_EDIT: '/inventory/edit/:itemId',

  // Admin routes
  ADMIN: '/admin',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_SUPERMARKETS: '/admin/supermarkets',
  ADMIN_SUPERMARKETS_CREATE: '/admin/supermarkets/create',
  ADMIN_SUPERMARKETS_EDIT: '/admin/supermarkets/edit/:id',
  ADMIN_PRODUCTS: '/admin/products',
  ADMIN_PRODUCTS_CREATE: '/admin/products/create',
  ADMIN_PRODUCTS_EDIT: '/admin/products/edit/:id',
  ADMIN_REPORTS: '/admin/reports',
  ADMIN_UNPROCESSED_PAYMENTS: '/admin/unprocessed-payments',

  // Employee routes
  EMPLOYEE_DASHBOARD: '/employee/dashboard',
  EMPLOYEE_PACK_ORDER: '/employee/pack-order/:transactionId',
  EMPLOYEE_MANAGE_ORDERS: '/employee/manage-packed-orders',
} as const;

export const PROTECTED_ROUTES = [
  ROUTES.INVENTORY,
  ROUTES.INVENTORY_CREATE,
  ROUTES.INVENTORY_EDIT,
  ROUTES.ADMIN,
  ROUTES.ADMIN_DASHBOARD,
  ROUTES.ADMIN_SUPERMARKETS,
  ROUTES.ADMIN_SUPERMARKETS_CREATE,
  ROUTES.ADMIN_SUPERMARKETS_EDIT,
  ROUTES.ADMIN_PRODUCTS,
  ROUTES.ADMIN_PRODUCTS_CREATE,
  ROUTES.ADMIN_PRODUCTS_EDIT,
  ROUTES.ADMIN_REPORTS,
  ROUTES.ADMIN_UNPROCESSED_PAYMENTS,
  ROUTES.EMPLOYEE_DASHBOARD,
  ROUTES.EMPLOYEE_PACK_ORDER,
  ROUTES.EMPLOYEE_MANAGE_ORDERS,
] as const;

export const ADMIN_ROUTES = [
  ROUTES.ADMIN,
  ROUTES.ADMIN_DASHBOARD,
  ROUTES.ADMIN_SUPERMARKETS,
  ROUTES.ADMIN_SUPERMARKETS_CREATE,
  ROUTES.ADMIN_SUPERMARKETS_EDIT,
  ROUTES.ADMIN_PRODUCTS,
  ROUTES.ADMIN_PRODUCTS_CREATE,
  ROUTES.ADMIN_PRODUCTS_EDIT,
  ROUTES.ADMIN_REPORTS,
  ROUTES.ADMIN_UNPROCESSED_PAYMENTS,
] as const;

export const EMPLOYEE_ROUTES = [
  ROUTES.INVENTORY,
  ROUTES.INVENTORY_CREATE,
  ROUTES.INVENTORY_EDIT,
  ROUTES.EMPLOYEE_DASHBOARD,
  ROUTES.EMPLOYEE_PACK_ORDER,
  ROUTES.EMPLOYEE_MANAGE_ORDERS,
  ROUTES.ADMIN_PRODUCTS,
  ROUTES.ADMIN_REPORTS,
] as const;
